<template>
  <div class="notice_mng">
    <div class="title-box">
      <div class="title-box-left">
        <h2 class="title-box-title">培训手册</h2>
      </div>
      <div class="title-box-right">
        <span class="title-box-button-1 mr20" @click="download()">导出</span>
        <span class="title-box-button-1" @click="preview()">预览效果</span>
      </div>
    </div>
    <section class="pd2430">
      <ul class="tabs-box">
        <li
          class="tabs-item"
          :class="[
            item.class,
            index == tabsActivity ? `tabs-item-activity-${index + 1}` : '',
          ]"
          v-for="(item, index) in tabs"
          :key="index"
          @click="tabsChange(index, item)"
          v-if="item.display"
        >
          <i class="tabs-icon"></i>
          <span class="tabs-text">{{ item.text }}</span>
        </li>
      </ul>
      <Editor v-model="editor" :min-height="500" v-if="editorShow"> </Editor>
      <div class="operate-box">
        <el-button type="primary" @click="submit()">保存</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import {
  getApiTrainingHandbookList,
  getApiTrainingHandbookDetails,
  getApiTrainingHandbookExport,
  putApiTrainingHandbook,
} from "@/api/tearcher";
export default {
  data() {
    return {
      //表单数据
      formData: {
        class_id: sessionStorage.getItem("class_id"),
      },
      dictionary: {}, //全部字典
      //tabs列表
      tabs: [],
      tabsActivity: 0, //tabs活动位置
      editor: "", //手册内容
      editorShow: true, //是否显示富文本
    };
  },
  methods: {
    //导出
    download() {
      let id = [];
      if (this.tabs.length > 0) {
        this.tabs.forEach((item) => {
          id.push(item.id);
        });
      }
      getApiTrainingHandbookExport({ id: id.join(",") }).then((res) => {
        saveAs(res, "培训手册.docx");
      });
    },
    //预览
    preview() {
      const routeData = this.$router.resolve({
        path: "/TrainingHandbookPreview",
        query: { id: this.formData.class_id },
      });
      window.open(routeData.href, "_blank");
    },
    //保存
    submit() {
      //修改培训手册
      putApiTrainingHandbook(this.tabs[this.tabsActivity].id, {
        content: this.editor,
      }).then((res) => {
        if (res.error_code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: messageDuration,
          });
        }
      });
    },
    //获取培训手册列表
    getTrainingHandbookList() {
      getApiTrainingHandbookList(this.formData).then((res) => {
        if (res.error_code == 200) {
          const list = res.data.data;
          if (list.length > 0) {
            list.forEach((item, index) => {
              this.tabs.push({
                text: item.title,
                class: `tabs-item-${index + 1}`,
                id: item.id,
                display: item.type == 1 || item.type == 2 ? true : false
              });
            });
            this.getTrainingHandbookDetails(list[0].id);
          }
        }
      });
    },
    //获取培训手册详情
    getTrainingHandbookDetails(id) {
      getApiTrainingHandbookDetails(id).then((res) => {
        if (res.error_code == 200) {
          this.editor = res.data.content;
          this.editorShow = true;
        }
      });
    },
    //tabs变更
    tabsChange(index, e) {
      this.tabsActivity = index;
      this.editorShow = false;
      this.getTrainingHandbookDetails(e.id);
    },
  },
  created() {
    this.dictionary = JSON.parse(localStorage.getItem("dictionary")); //获取全部字典
    this.getTrainingHandbookList();
  },
};
</script>

<style lang="less" scoped>
.pd2430 {
  padding: 0 20px 20px 20px;
}
.operate-box {
  padding: 40px 20px 10px 20px;
  display: flex;
  justify-content: center;
}
</style>
